import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../layout/spinner/spinner.component';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PostsService } from 'src/app/services/posts/posts.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admins',
  imports: [CommonModule, FormsModule, SpinnerComponent, ReactiveFormsModule],
  templateUrl: './admins.component.html',
  styleUrl: './admins.component.css'
})
export class AdminsComponent {
    load = false
    error = false
    data: any

    @ViewChild('editAdminModal') editAdminModalRef!: TemplateRef<any>;

    btnLoad = false;
    isEditMode = false;
    editBtnLoad = false;

    postsLoad = false
    postsError = false

    form!: FormGroup

    postCategoriesList: any

    deleteUserId = 0

    constructor(
      private AdminService: AdminService,
      private modalService: NgbModal,
      private fb: FormBuilder,
      private PostsService: PostsService,
      private ToastrService: ToastrService
    ){
      this.getAdmins()
      this.getPageItems()

     this.form = this.fb.group({
      id: [null],
      user: '',
      name: '',
      lastname: '',
      password: '',
      repeatPassword: '',
      role: 'admin',
      permission: [],
      postCategories: []
     })

    }


    getAdmins(){
      this.load = true
      this.AdminService.getAdmins().subscribe(
        (res: any) => {
          this.load = false
          this.error = false
          // აქ გადაყავთ სტრინგები მასივებად
          this.data = res.map((admin: any) => ({
            ...admin,
            permission: admin.permission ? JSON.parse(admin.permission) : [],
            postCategories: admin.postCategories ? JSON.parse(admin.postCategories) : []
          }));
        },
        (error: any) => {
          this.load = false
          this.error = true

        }
      )
    }

    getPageItems(){
      this.postsLoad = true
      this.PostsService.getPageItems().subscribe(
        (res: any) => {
          this.postCategoriesList = res;
          this.postsLoad = false
          this.postsError = false
        },
        (error: any) => {
          console.log(error)
          this.postsLoad = false
          this.postsError = true
        }
      );
    }


    openModalForAdd() {
      this.form.reset({
        id: [null],
        user: '',
        name: '',
        lastname: '',
        password: '',
        repeatPassword: '',
        role: 'admin',
        permission: [[]],
        postCategories: [[]]
      });
      this.isEditMode = false;
      this.modalService.open(this.editAdminModalRef, { size: 'lg' });
    }

    openEditAdminModal(user: any) {
      this.isEditMode = true;

      this.form.patchValue({
        id: user.id || null,
        user: user.user || null,
        name: user.name || null,
        lastname: user.lastname || null,
        password: user.password || null,
        role: user.role || null,
        permission: user.permission ? [...user.permission] : [],
        postCategories: user.postCategories ? [...user.postCategories] : []
      });

      this.modalService.open(this.editAdminModalRef);
    }




    onPermissionChange(event: Event) {
      const checkbox = event.target as HTMLInputElement;
      const currentPermissions = this.form.get('permission')?.value || [];

      if (checkbox.checked) {
        this.form.get('permission')?.setValue([...currentPermissions, checkbox.value]);
      } else {
        this.form.get('permission')?.setValue(
          currentPermissions.filter((p: string) => p !== checkbox.value)
        );
      }
    }

    onPostCategoryChange(event: Event) {
      const checkbox = event.target as HTMLInputElement;
      const selected = this.form.get('postCategories').value || [];

      if (checkbox.checked) {
        this.form.get('postCategories').setValue([...selected, checkbox.value]);
      } else {
        this.form.get('postCategories').setValue(
          selected.filter((id: string) => id !== checkbox.value)
        );
      }
    }

    submitEditAdmin(modal: any) {
      console.log(this.form.value)
      if(this.isEditMode){

        this.editBtnLoad = true;
        this.AdminService.updateAdmin(this.form.value).subscribe(
          (res: any) => {
            this.getAdmins()
            this.ToastrService.success('ადმინი წარმატებით დარედაქტირდა');
            this.editBtnLoad = false;
          },
          () => {
            this.editBtnLoad = false;
            this.ToastrService.error('შეცდომა ადმინის დარედაქტირებისას');
        })

      }else {

        this.editBtnLoad = true;
        this.AdminService.addAdmin(this.form.value).subscribe(
          (res: any) => {
            this.getAdmins()
            this.editBtnLoad = false;
            this.ToastrService.success('ადმინი წარმატებით დაემატა');
            modal.close();
          },
          () => {
            this.editBtnLoad = false;
            this.ToastrService.error('შეცდომა ადმინის დამატებისას');
          }
        );

      }
      
    }


    confirmDelete(user: any){
      if(confirm('ნამდვილათ გსურთ წაშალოთ ადმინი: ' + user.name)){
        this.deleteUserId = user.id
        this.AdminService.detete(user.id).subscribe(
          (res: any) => {
            this.getAdmins()
            this.ToastrService.success('ადმინი წაიშალა')
            this.deleteUserId = 0
          },
          (error: any) => {
            this.ToastrService.error('შეცდომა ადმინის წაშლისას')
            this.deleteUserId = 0
          }
        )
      }
    }

}


 